import { useInfiniteQuery } from 'react-query'
import { historyPayments } from 'services/bankManagements'

export default function useGetDetails(id: number) {
    const { data, isLoading, fetchNextPage, isFetching } = useInfiniteQuery(
        ['infinite-for-card-management-history', id],
        ({ pageParam = 1, queryKey }) => historyPayments(id, pageParam),
        {
            getNextPageParam: (lastPage, allPages) => {
                const lastRecord = allPages[allPages.length - 1]?.next || ''
                return lastRecord
                    ? new URL(lastRecord).searchParams.get('cursor')
                    : undefined
            },
        }
    )
    return { data, isLoading, fetchNextPage, isFetching }
}
